
export default function toLowerCase (url: string) {
	return url.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/ /g, '-').replace('%', '').replace('&', '').replace(',', '').replace('--', '-');
}
